import React from 'react';
import { List } from '@material-ui/core';
import { NavLink, useLocation } from 'react-router-dom';

import IntlMessages from '../../../util/IntlMessages';

const NavMenuItem = (props) => {
  const { name, icon, link } = props;
  const location = useLocation();

  const customIsActive = (navLinkLocation) => {
    const currentPathname = navLinkLocation?.pathname || location?.pathname;

    if (!currentPathname) {
      return false;
    }
    if (link === currentPathname) {
      return true;
    }
    if (currentPathname.startsWith(`${link}/`)) {
      return true;
    }
    if (currentPathname.startsWith('/app/create/user/')) {
      const itemType = link.split('/').pop();
      const currentTypeInCreatePath = currentPathname.split('/').pop();
      if (itemType && currentTypeInCreatePath === itemType) {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      <List component="div" className="nav-menu-item">
        <NavLink className="prepend-icon nav-menu-link" to={link} isActive={customIsActive} exact={false}>
          {/* Display an icon if any */}
          {!!icon && <i className={'zmdi zmdi-hc-fw  zmdi-' + icon} />}
          <span className="nav-text">
            <IntlMessages id={name} />
          </span>
        </NavLink>
      </List>
      {props?.dividerContent && (
        <List component="div" className="nav-menu-item">
          <div className="nav-menu-divider">{props?.dividerContent}</div>
        </List>
      )}
    </>
  );
};

export default NavMenuItem;
